import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'
import { UserRole } from '../../types'

interface AdminAuthGuardProps {
  children: React.ReactNode
}

export function AdminAuthGuard({ children }: AdminAuthGuardProps) {
  const { user, isAuthenticated } = useAuthStore()

  // Not authenticated at all
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />
  }

  // Authenticated but not SUPER_ADMIN
  if (user.role !== UserRole.SUPER_ADMIN) {
    return <Navigate to="/dashboard" replace />
  }

  // SUPER_ADMIN - allow access
  return <>{children}</>
}
